"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSurvey = void 0;
var axios_1 = require("axios");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../utils");
/**
 * @function postSurvey
 * @description Envia toda la data de la encuesta por medio de una petición POST.
 * @params Token: string de autenticación
 *         body: Todo el objeto de la encuesta que se va a enviar en la petición.
 * @return Promesa con la información que retorna la petición POST.
 */
function postSurvey(body) {
    var urlSurvey = (0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations).survey
        .urlSendSurvey;
    return (0, rxjs_1.from)(axios_1.default.post("".concat(urlSurvey), body)).pipe((0, operators_1.retry)(utils_1.PIPES_CONFIG.retry), (0, operators_1.catchError)(function (error) {
        console.error("Error saving survey information on data base: ", error);
        return error;
    }));
}
exports.postSurvey = postSurvey;
;
exports.default = {
    postSurvey: postSurvey
};
//# sourceMappingURL=survey-model.js.map